<template>

    <TransitionRoot
    :show="showing"
    appear
    as="template">
    <Dialog @close="$emit('close-nav')" as="div" class="fixed inset-0 z-[1999] overflow-hidden" >
        <div class="fixed inset-0 flex">

            <TransitionChild
                enter="transition duration-500 ease-in-out transform"
                enter-from="translate-x-full"
                enter-to="translate-x-0"
                leave="transition duration-150 ease-in-out transform"
                leave-from="translate-x-0"
                leave-to="translate-x-full"
                as="template"
                appear>
                    <div class="bg-purple relative w-screen">




                        <div class="image place-items-center absolute inset-0 grid h-screen">
                            <img :src="image" class="grayscale brightness-125 mix-blend-multiply w-3/5 max-w-[500px] opacity-70">
                        </div>

                         <div class="small-logo absolute inset-x-0 bottom-[25px]  flex justify-center text-black">
                            <img src="/assets/images/logo_small.svg" width="40" height="26" class="w-[40px] h-[26px] ">
                        </div>

                         <div class="menu-items font-brick place-items-center grid h-screen">
                            <div class="container container-w-6 w-full">
                                <ul class="md:text-6xl mb-0 text-4xl">
                                    <TransitionChild
                                        :enter="enterClasses(count)"
                                        enter-from="opacity-0 translate-x-12"
                                        enter-to="opacity-100 translate-x-0"
                                        as="li"
                                        v-for="(entry,count) in entries"
                                        :key="entry.id"
                                        class="flex justify-between"
                                        >
                                        <a :href="entry.url" class="hover:text-gray-300 focus-within:outline-none block text-white transition duration-150">{{ entry.title }}</a>
                                    </TransitionChild>
                                </ul>
                            </div>
                        </div>





                        <button @click="$emit('close-nav')" class="border-none focus-visible:outline-none focus:outline-none absolute text-white top-[38px] right-[23px]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1" viewBox="5.5 5.5 13 13">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                            </button>


                    </div>

            </TransitionChild>





        </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>

    import { ref } from 'vue'

    import {
        Dialog,
        TransitionChild,
        TransitionRoot,
    } from "@headlessui/vue";

    const closeButtonRef = ref(null)

    function enterClasses(count) {
        // console.log("transition-opacity ease-linear duration-3000 delay-"+(400*(count+1)));
        return "transition ease-in-out duration-300 transform delay-"+(250*(count+1));
    }

    const props = defineProps({
        showing: {
            required: true,
            type: Boolean
        },
        entries: {
            required: true,
            type: Array,
        },
        image: {
            required: true,
            type: String,
        },
    })

</script>
